export default ['$rootScope', 'api', function ($rootScope, api) {
    const buildUrl = (report, dateFrom, dateTo, showGroup, showGlobal, scopeProperties, number) => {
        if (!this.propertyId) {
            this.propertyId = $rootScope.currentProperty.id;
        }
        let url = `/api/${this.propertyId}/data?report=${report}&date_from=${dateFrom}&date_to=${dateTo}&group=${showGroup}`;
        if (showGlobal) {
            url = `${url}&global=true`;
        }
        if (scopeProperties) {
            url = `${url}&${scopeProperties}=true`;
        }
        if (number) {
            url = `${url}&number=${number}`;
        }

        return url;
    };

    return {
        setPropertyId: (propertyId) => { this.propertyId = propertyId; },
        getData: (report, dateFrom, dateTo, showGroup = false, showGlobal = false, scopeProperties = false, number = null) => {
            return api.get(buildUrl(report, dateFrom, dateTo, showGroup, showGlobal, scopeProperties, number)).then(response => response.data);
        },
        getIntegrationData: (report) => {
            if (!this.propertyId) {
                this.propertyId = $rootScope.currentProperty.id;
            }
            return api.get(`/api/${this.propertyId}/integrationData?report=${report}`).then(response => response.data);
        },
        sendCommissionReport: (type) => {
            return api.get(`/api/tasks/commissionReport?range=${type}`);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/dashboard/services/data.api.service.js